import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";

export const UpdateBtns = ({ params }) => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.multiLocation.filtersDirty);

  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.requestNewTableData())}>
        Update
      </button>
      <button
        className="submit reset"
        onClick={() => dispatch(actionCreators.fetchTableData(params))}
      >
        Reset
      </button>
    </>
  ) : (
    ""
  );
};
